<div [formGroup]="formularzUszkodzenia">
    <label class="c-label">
        <span [class.text-danger]="SZEROKOSC.errors && (SZEROKOSC.touched || SZEROKOSC.dirty)" class="c-label__title">Szerokość (m)</span>
        <input id='szerokosc' formControlName="szerokosc" type="number" class="c-input" value="" title="">
        <span *ngIf="SZEROKOSC.errors && (SZEROKOSC.touched || SZEROKOSC.dirty)" class="c-label__title text-danger u-margin-right-tiny">
            Dane powinny być z zakresu od {{minimalnaSzerokosc?.toFixed(2) | number:'':language }} do {{maksymalnaSzerokosc?.toFixed(2) | number:'':language}}
        </span>
    </label>
</div>
